/* =====================================
   GLOBAL DIAMOND MONTREAL - APPOINTMENT PAGE V2
   5 step consultation form (snippets/appointment-v2-form.liquid)
   ===================================== */
(function () {
  var form = document.querySelector('[data-apv2-form]');
  if (!form) return;

  var TOTAL = 5;
  var CHIP_FIELDS = ['ring_style', 'diamond_shape', 'ring_aspect', 'metal_color'];
  var UTM_KEYS = ['utm_source', 'utm_campaign', 'utm_medium', 'utm_content', 'gclid'];

  var steps = form.querySelectorAll('[data-apv2-step]');
  var dots = form.querySelectorAll('[data-apv2-dot]');
  var errorEl = form.querySelector('[data-apv2-error]');
  var chipsEl = form.querySelector('[data-apv2-chips]');
  var submitBtn = form.querySelector('[data-apv2-submit]');
  var moreBtn = form.querySelector('[data-apv2-more]');
  var current = 1;
  var reached = 1;
  var advanceTimer = null;
  var validated = false;

  /* ── Helpers ────────────────────────────────────────── */
  function stepEl(n) {
    return form.querySelector('[data-apv2-step="' + n + '"]');
  }

  /* Radio name attributes are the GHL custom field names, so answers are looked up by group key */
  function checkedIn(key) {
    return form.querySelector('[data-apv2-group="' + key + '"] input:checked');
  }

  function value(key) {
    var checked = checkedIn(key);
    return checked ? checked.value : '';
  }

  function label(key) {
    var checked = checkedIn(key);
    if (!checked) return '';
    var box = checked.parentNode.querySelector('.apv2f-opt__name') || checked.parentNode.querySelector('.apv2f-opt__box');
    return box ? box.textContent.trim() : checked.value;
  }

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  function clearError() {
    errorEl.textContent = '';
    errorEl.hidden = true;
  }

  function missingGroup(n) {
    var groups = stepEl(n).querySelectorAll('[data-apv2-group]');
    for (var i = 0; i < groups.length; i++) {
      if (!value(groups[i].getAttribute('data-apv2-group'))) return groups[i];
    }
    return null;
  }

  function getUtm(key) {
    try {
      if (window.__utmParams && window.__utmParams[key]) return window.__utmParams[key];
      var stored = sessionStorage.getItem(key);
      if (stored) return stored;
      return new URLSearchParams(window.location.search).get(key) || '';
    } catch (e) {
      return '';
    }
  }

  /* ── Rendering ──────────────────────────────────────── */
  function renderChips() {
    chipsEl.innerHTML = '';
    if (current > 1) {
      CHIP_FIELDS.forEach(function (name) {
        var text = label(name);
        if (!text) return;
        var chip = document.createElement('span');
        chip.className = 'apv2f__chip';
        chip.textContent = text;
        chipsEl.appendChild(chip);
      });
    }
    chipsEl.hidden = !chipsEl.children.length;
  }

  function goTo(n, focus) {
    clearTimeout(advanceTimer);
    current = Math.max(1, Math.min(TOTAL, n));
    reached = Math.max(reached, current);
    for (var i = 0; i < steps.length; i++) {
      steps[i].hidden = Number(steps[i].getAttribute('data-apv2-step')) !== current;
    }
    for (var j = 0; j < dots.length; j++) {
      var num = Number(dots[j].getAttribute('data-apv2-dot'));
      dots[j].classList.toggle('is-done', num <= current);
      dots[j].classList.toggle('is-current', num === current);
      if (num === current) dots[j].setAttribute('aria-current', 'step');
      else dots[j].removeAttribute('aria-current');
    }
    clearError();
    renderChips();
    if (focus) {
      var title = stepEl(current).querySelector('.apv2f__title');
      if (title) {
        title.setAttribute('tabindex', '-1');
        title.focus({ preventScroll: true });
      }
      var top = form.getBoundingClientRect().top;
      if (top < 0) window.scrollTo({ top: window.pageYOffset + top - 110, behavior: 'smooth' });
    }
  }

  function next() {
    if (missingGroup(current)) {
      showError('Please choose an option for each question.');
      return;
    }
    goTo(current + 1, true);
  }

  /* ── Events ─────────────────────────────────────────── */
  form.addEventListener('click', function (e) {
    var target = e.target.closest('[data-apv2-next], [data-apv2-back], [data-apv2-dot], [data-apv2-more]');
    if (!target) return;
    if (target.hasAttribute('data-apv2-next')) return next();
    if (target.hasAttribute('data-apv2-back')) return goTo(current - 1, true);
    if (target.hasAttribute('data-apv2-dot')) {
      var num = Number(target.getAttribute('data-apv2-dot'));
      if (num < current) goTo(num, true);
      return;
    }
    var panel = document.getElementById(moreBtn.getAttribute('aria-controls'));
    var open = moreBtn.getAttribute('aria-expanded') !== 'true';
    moreBtn.setAttribute('aria-expanded', String(open));
    panel.hidden = !open;
  });

  /* Choice steps advance on their own once every question is answered */
  form.addEventListener('change', function (e) {
    if (e.target.type !== 'radio') {
      e.target.classList.remove('is-invalid');
      return;
    }
    clearError();
    clearTimeout(advanceTimer);
    if (current < TOTAL && !missingGroup(current)) {
      var from = current;
      advanceTimer = setTimeout(function () {
        if (current === from) goTo(from + 1, true);
      }, 350);
    }
  });

  form.addEventListener('input', function (e) {
    e.target.classList.remove('is-invalid');
  });

  /* ── Submit ─────────────────────────────────────────── */
  function invalid(field, msg) {
    field.classList.add('is-invalid');
    showError(msg);
    field.focus();
    return false;
  }

  function validateContact() {
    var name = form.elements.full_name;
    var phone = form.elements.phone;
    var email = form.elements.email;
    var consent = form.elements.consent;
    var digits = phone.value.replace(/\D/g, '');

    if (name.value.trim().length < 2) return invalid(name, 'Please enter your full name.');
    if (digits.length < 10 || digits.length > 15 || /^(\d)\1+$/.test(digits)) return invalid(phone, 'Please enter a valid phone number.');
    if (!/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/.test(email.value.trim())) return invalid(email, 'Please enter a valid email address, e.g. name@example.com.');
    if (!consent.checked) return invalid(consent, 'Please confirm your consent so we can respond to your inquiry.');
    return true;
  }

  /* GHL external tracking records the form on every submit event, so the form is only
     submitted (requestSubmit) once all steps and the contact details are valid. */
  function trySubmit() {
    clearError();
    for (var n = 1; n < TOTAL; n++) {
      if (missingGroup(n)) {
        goTo(n, true);
        showError('Please choose an option for each question.');
        return;
      }
    }
    if (current !== TOTAL) return goTo(TOTAL, true);
    if (!validateContact()) return;
    validated = true;
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  submitBtn.addEventListener('click', trySubmit);

  /* Enter must not trigger a native (untracked-validation) submit */
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.matches('input')) return;
    e.preventDefault();
    if (current === TOTAL) trySubmit();
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!validated) return;
    validated = false;

    var webhook = form.getAttribute('data-webhook');

    var digits = form.elements.phone.value.replace(/\D/g, '');
    var fullPhone = '+' + (digits.length === 10 ? '1' + digits : digits);
    var email = form.elements.email.value.trim();
    var isPhysical = value('meeting_location') === 'Physical';

    var payload = {
      ring_style: value('ring_style'),
      diamond_shape: value('diamond_shape'),
      metal_color: value('metal_color'),
      budget: value('budget'),
      ring_aspect: value('ring_aspect'),
      timeline: value('timeline'),
      full_name: form.elements.full_name.value.trim(),
      phone: fullPhone,
      email: email,
      meeting_location: isPhysical ? 'Physical' : 'Virtual / Online Meeting',
      consent: 'yes'
    };
    UTM_KEYS.forEach(function (key) {
      payload[key] = getUtm(key);
    });

    /* Also send each answer under its "... v2" field name (the radio name, same as GHL),
       next to the original keys so existing Zap mappings keep working */
    payload.form_version = 'v2';
    form.querySelectorAll('[data-apv2-group] input:checked').forEach(function (input) {
      payload[input.name] = input.value;
    });

    var idleText = submitBtn.textContent;
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    /* Give the GHL tracking request time to leave before the page navigates away */
    var settle = new Promise(function (resolve) { setTimeout(resolve, 1200); });
    var post = webhook
      ? fetch(webhook, { method: 'POST', body: new URLSearchParams(payload) }).then(function (res) {
          if (!res.ok) throw new Error('Server error ' + res.status);
        })
      : Promise.resolve();

    Promise.all([post, settle])
      .then(function () {
        var base = form.getAttribute(isPhysical ? 'data-physical-url' : 'data-online-url');
        window.location.href = base
          + (base.indexOf('?') === -1 ? '?' : '&')
          + 'ec_email=' + encodeURIComponent(email)
          + '&ec_phone=' + encodeURIComponent(fullPhone);
      })
      .catch(function (err) {
        console.error('Appointment form error:', err);
        showError('Something went wrong. Please try again or contact us directly.');
        submitBtn.disabled = false;
        submitBtn.textContent = idleText;
      });
  });

  goTo(1, false);
})();
